import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

// Add auth interceptor
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Public
export const getProducts = (params) => api.get("/products", { params });
export const getProduct = (id) => api.get(`/products/${id}`);
export const getCategories = () => api.get("/categories");
export const createOrder = (data) => api.post("/orders", data);
export const seedData = () => api.post("/seed?force=true");

// Admin
export const adminLogin = (data) => api.post("/admin/login", data);
export const adminGetProducts = () => api.get("/admin/products");
export const adminCreateProduct = (data) => api.post("/admin/products", data);
export const adminUpdateProduct = (id, data) => api.put(`/admin/products/${id}`, data);
export const adminDeleteProduct = (id) => api.delete(`/admin/products/${id}`);
export const adminGetOrders = () => api.get("/admin/orders");
export const adminUpdateOrderStatus = (id, status) => api.put(`/admin/orders/${id}/status?status=${status}`);

export default api;
